module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container container-fluid",
    attrs: {
      "id": "main-container"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row main-content row-lg-eq-height"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row outside-content row-lg-eq-height"
  }, [_c('marquee', [_vm._l((_vm.sigimera), function(sig) {
    return _c('a', {
      key: sig._id,
      attrs: {
        "href": sig.rdfs_seeAlso
      }
    }, [_vm._v("\n            " + _vm._s(sig.dc_title) + "   | \n          ")])
  }), _vm._v(" "), _vm._l((_vm.hResponse), function(hr) {
    return _c('a', {
      key: hr.id,
      attrs: {
        "href": hr.id
      }
    }, [_vm._v("\n            " + _vm._s(hr.label) + "   | \n          ")])
  }), _vm._v(" "), _vm._l((_vm.reliefWeb), function(rw) {
    return _c('a', {
      key: rw.id,
      attrs: {
        "href": rw.href
      }
    }, [_vm._v("\n            " + _vm._s(rw.fields.name) + "   | \n          ")])
  })], 2)], 1), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header-content row-lg-eq-height"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/osiris/static/img/logo_osiris_cores.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-ces",
    attrs: {
      "src": "/osiris/static/img/logo_ces.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row footer-content row-lg-eq-height"
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-left"
  }, [_c('strong', [_vm._v("Observatório do Risco OSIRIS")]), _c('br'), _vm._v("\n            Centro de Estudos Sociais (CES)"), _c('br'), _vm._v("\n            Universidade de Coimbra"), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_vm._v("\n            Colégio de S. Jerónimo"), _c('br'), _vm._v("\n            Apartado 3087"), _c('br'), _vm._v("\n            3001-401 Coimbra"), _c('br'), _vm._v("\n            PORTUGAL"), _c('br'), _vm._v("\n            Telefone: +351239855590"), _c('br'), _vm._v("\n            E-mail: osiris@ces.uc.pt"), _c('br'), _vm._v("\n            www.ces.uc.pt/osiris\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc235ee6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 80
// module chunks = 1